export default "__VITE_ASSET__DjTHxDzo__"